import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MapPin } from "lucide-react";

interface GymAddressFieldProps {
  gymAddress: string;
  setGymAddress: (address: string) => void;
  isEditing: boolean;
}

export const GymAddressField = ({
  gymAddress,
  setGymAddress,
  isEditing,
}: GymAddressFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="gymAddress" className="flex items-center gap-2 text-muted-foreground">
        <MapPin className="h-4 w-4" />
        Dirección
      </Label>
      <Input
        id="gymAddress"
        value={gymAddress}
        onChange={(e) => setGymAddress(e.target.value)}
        disabled={!isEditing}
        placeholder="Ingresa la dirección del gimnasio"
        className="bg-background/50 border-input/50 focus:border-primary focus:bg-background transition-all"
      />
    </div>
  );
};